export default __webpack_public_path__ + "static/media/Talent Pool.ef3f7224.png";